/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type DeleteAIConfigSandboxPathParams = NonNullable<operations['deleteAIConfigSandbox']['parameters']['path']>;

export type DeleteAIConfigSandboxQueryParams = NonNullable<operations['deleteAIConfigSandbox']['parameters']['query']>;

export interface Input extends DeleteAIConfigSandboxPathParams {
  apiVersion?: string;
  query: DeleteAIConfigSandboxQueryParams;
  header: NonNullable<operations['deleteAIConfigSandbox']['parameters']['header']>;
}

export async function deleteAIConfigSandbox(
  { apiVersion, query, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/projects/{projectKey}/ai-configs/{configKey}/sandbox', {
    params: { path, query, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
